<template>
  <div class="row mt-0">
    <div class="col-12 col-md-6 col-lg-4">
      <atom-select
        v-model="inventoryFilter.status"
        title="Status"
        placeholder="All Status"
        label="name"
        :option="inventoryStatusOption"
      ></atom-select>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
      <atom-multi-select
        v-model="inventoryFilter.types"
        title="Types"
        placeholder="All Types"
        label="name"
        :option="inventoryTypeOption"
      ></atom-multi-select>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"

export default {
  name: "MoleculeReportFilterInventory",
  components: { AtomSelect, AtomMultiSelect },
  props: {
    value: {
      type: Object,
      required: true,
    },
    inventoryStatusOption: {
      type: Array,
      required: true,
    },
    inventoryTypeOption: {
      type: Array,
      required: true,
    },
  },

  computed: {
    inventoryFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
